import * as yup from "yup";

const schema = yup.object().shape({
  parameter: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for Test Parameter")
    .label("Test Parameter"),
  amount: yup
    .string()
    .matches(/^[0-9]+$/, "Please enter a valid value for price")
    .required()
    .label("Price"),
  currency: yup.string().required().label("Currency"),
  commodityCategory: yup.string().required().label("Commodity Category"),
  commodity: yup.string().required().label("Commodity"),
  testCategory: yup.string().required().label("Test Category"),
  description: yup.string().label("Test Description"),
});

export default schema;
